import React from 'react';

const LogoutConfirmModal = ({ showLogoutConfirm, setShowLogoutConfirm, handleSignOut }) => {
  if (!showLogoutConfirm) return null;
  
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4 text-center">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-25 transition-opacity"
          aria-hidden="true"
          onClick={() => setShowLogoutConfirm(false)}
        />

        {/* Modal */}
        <div className="relative inline-block w-full max-w-md transform overflow-hidden rounded-lg bg-brand-teal p-6 text-left align-middle shadow-xl transition-all">
          <h3 className="text-lg font-medium leading-6 text-white">
            Sign out
          </h3>
          
          <div className="mt-2">
            <p className="text-sm text-white">
              Are you sure you want to sign out?
            </p>
          </div>

          <div className="mt-4 flex space-x-3">
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent bg-brand-orange px-4 py-2 text-sm font-medium text-white hover:bg-brand-orange-light focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2"
              onClick={handleSignOut}
            >
              Yes, sign out
            </button>
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-white bg-transparent px-4 py-2 text-sm font-medium text-white hover:bg-brand-teal-dark focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
              onClick={() => setShowLogoutConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal; 